<template>
    <div class="info-grid-container">
        <div class="grid-item">
            <div class="item-header">
                特徴
            </div>
            <div class="item-content">
                <div class="double-circle"></div>
                <p><span>追加費用一切なし</span></p>
            </div>
        </div>
        <div class="grid-item">
            <div class="item-header">
                本体最大割引
            </div>
            <div class="item-content">
                <div class="double-circle"></div>
                <p><span>最大82%OFF</span></p>
            </div>
        </div>
        <div class="grid-item">
            <div class="item-header">
                対応スピード
            </div>
            <div class="item-content">
                <div class="double-circle"></div>
                <p><span>最短即日対応</span></p>
            </div>
        </div>

        <div class="grid-item">
            <div class="item-header">
                保証
            </div>
            <div class="item-content">
                <div class="double-circle"></div>
                <p><span>工事・商品10年</span></p>
            </div>
        </div>
        <div class="grid-item">
            <div class="item-header">
                ユーザー満足度
            </div>
            <div class="item-content">
                <div class="double-circle"></div>
                <p><span>Google口コミ4.9</span></p>
            </div>
        </div>
        <div class="grid-item">
            <div class="item-header">
                対応エリア
            </div>
            <div class="item-content">
                <div class="double-circle"></div>
                <p><span>関西</span></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InfoGrid',
};
</script>

<style scoped>
.annotation-txt {
    font-size: 10px;
    text-align: left;
    padding: 0;
    padding-left: 20px;
    margin: 0;
    margin-bottom: 5px;
    padding-bottom: 10px;
}

.info-grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 10px;
    padding-bottom: 5px;
    margin-bottom: 20px;
}

.grid-item {
    border: 1px solid #ddd;
    overflow: hidden;
}

.item-header {
    background-color: #5d7ac9;
    color: white;
    font-weight: bold;
    text-align: center;
    padding: 10px 5px;
    font-size: 0.8rem;
}

.item-content {
    background-color: white;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px;
}

.item-content p {
    padding: 0;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 0.8rem;
}

.content-icon {
    width: 40px;
    height: 40px;
    margin-bottom: 5px;
}

.bold {
    font-weight: bold;
    font-size: 16px;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .info-grid-container {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }

    .item-header {
        font-size: 1rem;
        padding: 5px;
    }

    .item-content {
        font-size: 0.9rem;
        border: 1px solid gray;
    }

    .annotation-txt {
        font-size: 0.6rem;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .annotation {
        font-size: 0.6rem;
    }
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 480px) {
    .info-grid-container {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        margin: 0;
        padding: 5px;
        /* gap: 0; */
    }

    .item-header {
        font-size: 0.9rem;
        padding: 5px;
    }

    .item-content {
        font-size: 1rem;
        border: 1px solid gray;
    }

    .annotation-txt {
        font-size: 0.6rem;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .annotation {
        font-size: 0.6rem;
    }
}
</style>